import React, {Component} from 'react';
import {Link} from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FaInfo } from "react-icons/fa";

class AdminHistoryPaymentComponent extends Component {

    loadStatus = () => {
        if ( this.props.payment.status === 'Active' ) {
            return (
                <span className="text-success">
                    Đã thanh toán
                </span>
            )
        }
        else if ( this.props.payment.status === 'Waiting' ) {
            return (
                <span className="text-info">
                    Thanh toán chờ
                </span>
            )
        }
        else if ( this.props.payment.status === 'Pending' ) {
            return (
                <span className="text-danger">
                    Chưa thanh toán
                </span>
            )
        }
        else if ( this.props.payment.status === 'Cancel' ) {
            return (
                <span className="text-danger">
                    Hủy
                </span>
            )
        }

    }

    render() {
        return (
            <tr>
                <td>{ this.props.payment.ma_gd }</td>
                <td>
                    <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.props.payment.user_id}>{this.props.payment.text_user_name}</Link>
                </td>
                <td>{ this.props.payment.text_type_payment }</td>
                <td>{ this.props.payment.text_total_agency }</td>
                <td>{ this.props.payment.text_total }</td>
                <td>{ this.props.payment.text_create_date }</td>
                <td>{ this.props.payment.text_payment_date }</td>
                <td>
                    {
                        this.props.payment.status !== 'Pending' ? (
                            <>
                                {this.props.payment.text_before_credit}
                            </>
                        ) : (
                            <></>
                        )
                    }
                </td>
                <td>
                    {
                        this.props.payment.status !== 'Pending' ? (
                            <>
                                {this.props.payment.text_after_credit}
                            </>
                        ) : (
                            <></>
                        )
                    }
                </td>
                <td>{ this.loadStatus() }</td>
                <td>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chi tiết giao dịch
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <Link
                            to={"/admin/quan-ly-giao-dich/" + this.props.payment.id + '/chi-tiet-giao-dich.html'}
                            className="btn btn-info btn-sm mr-1"
                        >
                            <FaInfo />
                        </Link>
                    </OverlayTrigger>
                </td>
            </tr>
        );
    }
}

export default AdminHistoryPaymentComponent;